export default __webpack_public_path__ + "static/media/mitigation-exposed-framing-drying-1.4845621d.jpg";